import { render, staticRenderFns } from "./College.vue?vue&type=template&id=43f55e58&scoped=true"
import script from "./College.vue?vue&type=script&lang=js"
export * from "./College.vue?vue&type=script&lang=js"
import style0 from "./College.vue?vue&type=style&index=0&id=43f55e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f55e58",
  null
  
)

export default component.exports